export default __webpack_public_path__ + "f4ed316dcf12e6300b573eb9f38d18e5.jpg";